/**
 * HTML Entity Encode Tool
 */

import { SEMANTIC_TYPES } from '@/detectors/semanticTypes';
import type { ITransformerTool } from '@/interfaces/ITool';

export const HtmlEntityEncodeTool: ITransformerTool = {
  id: 'html-entity-encode',
  name: 'HTML Entity Encode',
  description: 'Encode special characters as HTML entities',
  version: '1.0.0',
  type: 'transformer',
  category: 'Encoders & Decoders',
  keywords: ['html', 'entity', 'encode', 'escape'],

  supportedInputTypes: [SEMANTIC_TYPES.TEXT, SEMANTIC_TYPES.HTML],
  outputType: SEMANTIC_TYPES.TEXT,

  attributes: [
    {
      name: 'encodeMode',
      type: 'select',
      label: 'Encode Mode',
      defaultValue: 'minimal',
      options: ['minimal', 'numeric'],
      description: 'minimal: only < > & ". numeric: encode all non-ASCII to numeric entities.',
    },
  ],

  async transform(input: string, config: Record<string, unknown>): Promise<string> {
    const encodeMode = (config.encodeMode as string) || 'minimal';

    if (encodeMode === 'numeric') {
      return [...input].map(char => {
        const code = char.codePointAt(0)!;
        if (code > 127) {
          return `&#x${code.toString(16).toUpperCase()};`;
        }
        // Still escape the standard HTML special chars
        switch (char) {
          case '&': return '&amp;';
          case '<': return '&lt;';
          case '>': return '&gt;';
          case '"': return '&quot;';
          default: return char;
        }
      }).join('');
    }

    const el = document.createElement('textarea');
    el.textContent = input;
    return el.innerHTML;
  },
};
